export default __webpack_public_path__ + "static/media/ic_australia.f511b262.svg";